
import './DataTableReusable.scss'; // Optional styling
import { RxCross2 } from "react-icons/rx";

import { TiTick } from "react-icons/ti";


const DataTableReusable = ({ title, headers, rows, note, link }) => {
  
const renderIcon = (value) => {
  if (value === 'Tick') return <TiTick />;
  if (value === 'Tick*') return <><TiTick />*</>;
  if (value === 'Cross') return <RxCross2 />;
  return value;
};

  return (
    <div className="data-table">
      <h2>{title}</h2>
      <table>
        <thead>
          <tr>
            {headers.map((head, i) => (
              <th key={i}>{head}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, i) => (
            <tr key={i}>
              <td>{row.label}</td>
              {row.values.map((val, j) => (
                <td key={j}>{renderIcon(val)}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
      {note && <p className="table-note">{note}</p>}
      {note && <p className="table-link">{link}</p>}

    </div>
  );
};

export default DataTableReusable;
